import { InfoIcon } from 'lucide-react'

import ACAReportingHeader from './ACAReportingHeader'
import AleConfirmationForm from './AleConfirmationForm'

interface AleStatusConfirmationProps {
  planYear: number
  onConfirmed: (aleStatus: boolean) => void
  isExpired?: boolean
}

export default function AleStatusConfirmation ({
  planYear,
  onConfirmed,
  isExpired = false
}: AleStatusConfirmationProps) {
  return (
    <div className='space-y-6'>
      <ACAReportingHeader planYear={planYear} isFilingEligible={false} />

      <div className='bg-white rounded-2xl border border-gray-200 overflow-hidden'>
        <div className='bg-gray-50 border-b border-gray-200 px-6 py-4'>
          <div className='flex items-center gap-3'>
            <InfoIcon className='text-gray-500' size={20} />
            <span className='text-sm text-gray-700'>
              {isExpired
                ? 'The deadline has passed for opting into Thatch ACA filing, but Thatch can still provide your 1095 data in a .csv format.'
                : "You are not eligible for Thatch's ACA filing services, but Thatch can still provide your 1095 data in a .csv format."}
            </span>
          </div>
        </div>

        <div className='p-6'>
          <AleConfirmationForm
            planYear={planYear}
            onConfirmed={onConfirmed}
            showFormTypeHint
          />
        </div>
      </div>
    </div>
  )
}
